module.exports = __webpack_public_path__ + "static/media/star-empty.5ed871ce.svg";